(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function () {
    function initMainBlog(root) {
      if (!root || root.dataset.mbInit === 'true') return;
      root.dataset.mbInit = 'true';

      var step = parseInt(root.dataset.mbStep || '6', 10);
      if (isNaN(step) || step < 1) step = 6;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-tab]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mb-card]'));
      var loadMore = root.querySelector('[data-mb-loadmore]');
      var showingEls = Array.prototype.slice.call(root.querySelectorAll('[data-mb-showing]'));

      var activeCat = 'all';
      var visible = step;

      function catsOf(el) {
        return (el.getAttribute('data-categories') || '').split(/\s+/).filter(Boolean);
      }

      // Counts describe the GRID only — the featured hero sits above and isn't counted.
      var countables = cards.slice();

      function totalFor(cat) {
        if (cat === 'all') return countables.length;
        return countables.filter(function (el) { return catsOf(el).indexOf(cat) > -1; }).length;
      }

      // Fill in the tab count badges
      tabs.forEach(function (tab) {
        var badge = tab.querySelector('[data-mb-count]');
        if (badge) badge.textContent = totalFor(tab.getAttribute('data-mb-tab'));
      });

      function matchingCards() {
        return cards.filter(function (card) {
          return activeCat === 'all' || catsOf(card).indexOf(activeCat) > -1;
        });
      }

      function render() {
        var match = matchingCards();
        cards.forEach(function (card) { card.style.display = 'none'; });
        match.forEach(function (card, i) {
          card.style.display = i < visible ? '' : 'none';
        });

        var shown = Math.min(visible, match.length);
        var total = totalFor(activeCat);
        var label = 'Showing ' + shown + ' of ' + total + ' article' + (total === 1 ? '' : 's');
        showingEls.forEach(function (el) { el.textContent = label; });

        if (loadMore) loadMore.style.display = visible < match.length ? '' : 'none';
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          activeCat = tab.getAttribute('data-mb-tab');
          visible = step;
          render();
        });
      });

      if (loadMore) {
        loadMore.addEventListener('click', function () {
          visible += step;
          render();
        });
      }

      render();
    }

    function initAll() {
      document.querySelectorAll('.main-blog').forEach(initMainBlog);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when edited in the theme customizer
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.main-blog') : null;
      if (root) initMainBlog(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
